import React from 'react';
import PropTypes from 'prop-types';
import GLOBALS from '../config/globals';
import { formatShortDateOrToday } from '../helpers/dateHelpers';

const BadgeReward = ({ badge }) => {
    if (!badge) return null;

    const tierConfig = GLOBALS.BADGE_TIERS[badge.tier] ?? GLOBALS.BADGE_TIERS[1];
    // earnedAt is not set on freshly-awarded badges — use "now"
    const date = formatShortDateOrToday(badge.earnedAt);
    const sentence = badge.subject && badge.flavorText
        ? `${badge.subject} ${badge.flavorText} on ${date}`
        : badge.description;

    return (
        <div className={`badge-reward ${tierConfig.cssClass}`}>
            <div className="badge-reward__icon">
                <img
                    src={`/img/badges/${encodeURIComponent(badge.imageKey)}.png`}
                    alt={badge.name}
                    className="badge-reward__img"
                    onError={e => { e.currentTarget.style.display = 'none'; }}
                />
            </div>
            <div className="badge-reward__info">
                <div className="badge-reward__name">{badge.name}</div>
                <div className="badge-reward__sentence">{sentence}</div>
            </div>
        </div>
    );
};

BadgeReward.propTypes = {
    badge: PropTypes.shape({
        badgeID: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        name: PropTypes.string.isRequired,
        description: PropTypes.string,
        tier: PropTypes.number,
        imageKey: PropTypes.string.isRequired,
        flavorText: PropTypes.string,
        subject: PropTypes.string,
        earnedAt: PropTypes.string,
    }),
};

export default BadgeReward;
